<template>
  <div class="challenge-card list-group-item p-0" :class="approveClass()">
    <b-row class="m-0 w-100">
      <b-col cols="1" class="p-0 text-center handle" align-self="center">
        <span class="material-icons material-icons-outlined move">
          drag_indicator
        </span>
      </b-col>
      <b-col class="p-0" align-self="center" :class="'col-6'">
        <div class="d-flex align-items-center">
          <section
            class="align-items-center justify-content-center image-container-size ml-2 ml-md-0 text-center"
          >
            <b-img v-if="image" fluid :src="image" class="h-100 w-100 object-fit-cover rounded" />
            <span v-else class="material-icons text-warning font-big" style="top: 30%;"
              >emoji_events</span
            >
          </section>
          <b-col class="d-flex flex-column justify-content-center py-2">
            <section class="label">
              <span>{{ text }}</span>
            </section>
            <section class="d-flex flex-column flex-md-row align-items-start align-items-md-center">
              <div class="d-flex align-items-center">
                <b-img fluid :src="require(`@/assets/star.png`)" class="icon-star-small h-auto" />
                <span class="ml-1">{{ coinValue }}</span>
              </div>
              <div class="d-flex brands-container ml-0 ml-md-2">
                <div class="align-items-center" v-if="category.name">
                  <p
                    :style="`background-color:${category.color};`"
                    class="category-challenge-brand text-white px-2 py-1 small rounded-pill"
                  >
                    {{ category.name }}
                  </p>
                </div>
                <div class="align-items-center" v-if="frequencyValue">
                  <p
                    :style="`background-color:#e9ecef;`"
                    class="category-challenge-brand px-2 py-1 small "
                  >
                    {{ frequencyValue }}
                    <span
                      v-if="challengeHasValidFrequency"
                      class="material-icons military_tech text-warning align-middle"
                      >military_tech</span
                    >
                  </p>
                </div>
              </div>
            </section>
          </b-col>
        </div>
      </b-col>
      <b-col cols="2" class="p-0 text-center " align-self="center">
        <section class="check">
          <input
            :disabled="disabledInput"
            type="radio"
            class="d-none"
            v-model="approvedItem"
            :checked="approvedItem === value.approved"
            :value="value.approved"
            :id="`${criterionId}-check-yes-${challengeId}`"
            @click="handleSelect(value.approved)"
          />
          <label :for="`${criterionId}-check-yes-${challengeId}`"></label>
        </section>
      </b-col>
      <b-col cols="2" class="p-0 text-center" align-self="center">
        <section class="no-check">
          <input
            :disabled="disabledInput"
            type="radio"
            class="d-none"
            v-model="approvedItem"
            :checked="approvedItem === value.notApproved"
            :value="value.notApproved"
            :id="`${criterionId}-check-no-${challengeId}`"
            @click="handleSelect(value.notApproved)"
          />
          <label :for="`${criterionId}-check-no-${challengeId}`"></label>
        </section>
      </b-col>
      <b-col cols="1" class="p-0 text-center" align-self="center">
        <span
          class="material-icons material-icons-outlined pointer"
          :id="`popover-challenge-${challengeId}`"
          @click="showPopup = !showPopup"
        >
          more_vert
        </span>
        <b-popover
          :show.sync="showPopup"
          :target="`popover-challenge-${challengeId}`"
          placement="bottomleft"
        >
          <span class="d-block pointer pr-2" @click.stop="handleControlsCard('edit')">Edit</span>
          <span class="d-block pointer text-danger pr-2" @click.stop="handleControlsCard('delete')"
            >Delete</span
          >
        </b-popover>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  props: {
    checkAll: {
      type: Boolean,
      required: true,
    },
    image: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    category: {
      type: Object,
      default: () => ({
        color: '',
        name: '',
        id: 0,
      }),
    },
    frequencyValue: {
      type: String,
      default: '',
    },
    frequencyId: {
      type: String,
      default: '',
    },
    coinValue: {
      type: [String, Number],
      default: '',
    },
    challengeId: {
      type: [Number, String],
      default: 0,
    },
    criterionId: {
      type: [Number, String],
      default: 0,
    },
    defaultValue: {
      type: Object,
      default: () => ({
        approved: false,
        qualified: false,
      }),
    },
  },
  data() {
    return {
      approvedItem: [],
      showPopup: false,
      value: {
        approved: 1,
        notApproved: 0,
      },
    };
  },
  mounted() {
    if (this.defaultValue.qualified) {
      this.approvedItem = this.defaultValue.approved ? this.value.approved : this.value.notApproved;
    }
  },
  computed: {
    challengeHasValidFrequency() {
      return ['bonus_date', 'bonus_one_time'].includes(this.frequencyId);
    },
    disabledInput() {
      return this.defaultValue.qualified && this.defaultValue.approved;
    },
  },
  watch: {
    checkAll() {
      if (
        !this.defaultValue.qualified ||
        (this.defaultValue.qualified && !this.defaultValue.approved)
      ) {
        this.approvedItem = 1;
        this.$emit('onApprove', { approved: true });
      }
    },
  },
  methods: {
    approveClass() {
      if (!this.defaultValue.qualifiedByChild && !this.defaultValue.qualified) return '';
      const { qualifiedByChild, approved } = this.defaultValue;
      const approveStyle =
        qualifiedByChild && approved ? 'approved-challenge' : 'qualified-by-child';
      return this.disabledInput || qualifiedByChild ? approveStyle : 'disapproved-challenge';
    },
    handleSelect(selected) {
      let data = {};
      const isValidToDeselect =
        typeof this.approvedItem === 'number' && !this.defaultValue.qualified;
      if (isValidToDeselect && Number(selected) === Number(this.approvedItem)) {
        this.approvedItem = [];
        data = { approved: undefined };
      } else {
        data = { approved: selected === this.value.approved };
      }
      this.$emit('onApprove', data);
    },
    handleControlsCard(action) {
      if (action === 'delete') {
        this.$emit('onDeleteChallenge', { challengeId: this.challengeId });
      } else {
        this.$emit('onEditChallenge', { challengeId: this.challengeId });
      }
      this.showPopup = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.challenge-card {
  background-color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.2em;
  width: 100%;
  border-radius: 5px;
  box-shadow: 0px 1px 2px #ccc;

  &.approved-challenge {
    background-color: #c1ea94;
  }
  &.disapproved-challenge {
    background-color: #eabbba;
  }
}
.image-container-size {
  min-width: 80px;
  width: 80px;
  max-width: 80px;
  min-height: 80px;
  height: 80px;
  max-height: 80px;
}
.check label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 24px;
  left: 0;
  position: relative;
  top: 0;
  width: 24px;
  margin: 0;
}
.check label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: '';
  height: 6px;
  left: 6px;
  opacity: 0;
  position: absolute;
  top: 7px;
  transform: rotate(-45deg);
  width: 12px;
}
.check input[type='radio'] {
  visibility: hidden;
}
.check input[type='radio']:checked + label {
  background-color: var(--color-main);
  border-color: var(--color-main);
}
.check input[type='radio']:checked + label:after {
  opacity: 1;
}
.no-check label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 24px;
  left: 0;
  position: relative;
  top: 0;
  width: 24px;
  margin: 0;
}
.no-check label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: '';
  height: 2px;
  left: 5px;
  opacity: 0;
  position: absolute;
  top: 10px;
  width: 12px;
}
.no-check input[type='radio'] {
  visibility: hidden;
}
.no-check input[type='radio']:checked + label {
  background-color: var(--aside04);
  border-color: var(--aside04);
}
.no-check input[type='radio']:checked + label:after {
  opacity: 1;
}
.material-icons {
  cursor: default;
  font-size: 1.7rem;
}

.qualified-by-child {
  background-color: #ebfade;
}
</style>
